"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _InboxMessage = _interopRequireDefault(require("./InboxMessage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class InboxEditorChild extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      editing: false,
      expanded: false,
      replying: false,
      prevFormData: {},
      reply: {}
    });

    _defineProperty(this, "onToggle", () => {
      this.setState({
        expanded: !this.state.expanded
      });
    });

    _defineProperty(this, "onEdit", () => {
      const _this$props = this.props,
            id = _this$props.id,
            index = _this$props.index,
            schema = _this$props.schema,
            formData = _this$props.formData,
            formContext = _this$props.formContext;
      this.setState({
        prevFormData: formData,
        editing: true
      });

      if (formContext.onEditMessage) {
        formContext.onEditMessage({
          index: index,
          formData: formData
        });
      }
    });

    _defineProperty(this, "onChangeMessage", message => {
      const _this$props2 = this.props,
            index = _this$props2.index,
            formData = _this$props2.formData,
            formContext = _this$props2.formContext;

      const newFormData = _extends({}, formData, {
        message: message
      });

      if (this.props.onChange) {
        this.props.onChange(newFormData);
      }

      if (formContext.onChangeMessage) {
        formContext.onChangeMessage({
          index: index,
          formData: newFormData
        });
      }
    });

    _defineProperty(this, "onDiscardDraft", () => {
      const _this$props3 = this.props,
            id = _this$props3.id,
            index = _this$props3.index,
            schema = _this$props3.schema,
            formData = _this$props3.formData,
            formContext = _this$props3.formContext;

      if (formContext.onDiscardDraft) {
        formContext.onDiscardDraft({
          index: index,
          formData: formData
        });
      }

      if (this.props.onChange) {
        this.props.onChange(this.state.prevFormData);
      }

      this.setState({
        editing: false
      });
    });

    _defineProperty(this, "onReply", () => {
      const _this$props4 = this.props,
            id = _this$props4.id,
            index = _this$props4.index,
            schema = _this$props4.schema,
            formData = _this$props4.formData,
            formContext = _this$props4.formContext;
      const author = formContext.author;
      const parentId = formData.uniqueId;
      const replyTo = formData.author.name + " <" + formData.author.email + ">";
      const replyFrom = author.name + " <" + author.email + ">";
      const subject = "Re: " + formData.subject;
      const reply = {
        parentId: parentId,
        //            status: "draft",
        author: author,
        subject: subject,
        from: replyFrom,
        to: replyTo,
        message: ""
      };
      this.setState({
        replying: true,
        reply: reply
      });
    });

    _defineProperty(this, "onChangeReply", message => {
      this.setState({
        reply: _extends({}, this.state.reply, {
          message: message
        })
      });
    });

    _defineProperty(this, "onDiscardReply", () => {
      const _this$props5 = this.props,
            index = _this$props5.index,
            formContext = _this$props5.formContext;
      const reply = this.state.reply;

      if (formContext.onDiscardReply) {
        formContext.onDiscardReply({
          index: index,
          formData: reply
        });
      }

      this.setState({
        replying: false,
        reply: {
          expanded: false,
          message: ""
        }
      });
    });

    _defineProperty(this, "onSaveReply", status => {
      const _this$props6 = this.props,
            id = _this$props6.id,
            index = _this$props6.index,
            schema = _this$props6.schema,
            formContext = _this$props6.formContext;
      const reply = this.state.reply;

      if (!status) {
        status = "draft";
      }

      let newFormData = _extends({}, reply, {
        createdAt: (0, _moment.default)().format(),
        status: status
      });

      if (this.props.onAddAfter) {
        this.props.onAddAfter(newFormData);
      }

      if (formContext.onSaveReply) {
        formContext.onSaveReply({
          index: index,
          formData: newFormData
        });
      }

      this.setState({
        replying: false,
        reply: {}
      });
    });

    _defineProperty(this, "onSave", status => {
      const _this$props7 = this.props,
            id = _this$props7.id,
            index = _this$props7.index,
            schema = _this$props7.schema,
            formData = _this$props7.formData,
            formContext = _this$props7.formContext;

      if (!formData.status) {
        status = "draft";
      }

      let newFormData = _extends({}, formData, {
        createdAt: formData.createdAt || (0, _moment.default)().format(),
        updatedAt: (0, _moment.default)().format(),
        status: status
      });

      if (this.props.onChange) {
        this.props.onChange(newFormData);
      }

      if (formContext.onSaveMessage) {
        formContext.onSaveMessage({
          index: index,
          formData: newFormData
        });
      }

      this.setState({
        expanded: false,
        editing: false
      });
    });

    _defineProperty(this, "onDelete", () => {
      const _this$props8 = this.props,
            id = _this$props8.id,
            index = _this$props8.index,
            schema = _this$props8.schema,
            formData = _this$props8.formData,
            formContext = _this$props8.formContext;

      if (formContext.onDeleteMessage) {
        formContext.onDeleteMessage({
          index: index,
          formData: formData
        });
      }

      if (this.props.onDelete) {
        this.props.onDelete();
      }

      this.setState({
        expanded: false,
        editing: false
      });
    });

    _defineProperty(this, "getReplyButtons", () => {
      return [{
        label: "Send",
        onClick: () => this.onSaveReply(),
        children: [{
          label: "Save as draft",
          onClick: () => this.onSaveReply('draft')
        }, {
          label: "Save and publish",
          onClick: () => this.onSaveReply('publish')
        }]
      }, {
        label: "Discard",
        onClick: () => this.onDiscardReply()
      }];
    });

    _defineProperty(this, "getEditButtons", () => {
      return [{
        label: "Save",
        onClick: () => this.onSave(),
        children: [{
          label: "Save as open",
          onClick: () => this.onSave('open')
        }, {
          label: "Save and close",
          onClick: () => this.onSave('close')
        }]
      }, {
        label: "Delete",
        onClick: () => this.onDelete()
      }, {
        label: "Cancel",
        onClick: () => this.onDiscardDraft()
      }];
    });

    _defineProperty(this, "getToolbar", () => {
      const editable = this.props.editable;
      const reply = this.state.reply;

      if (reply.expanded) {
        return false;
      }

      let toolbar = [];
      toolbar.push({
        icon: "reply",
        onClick: () => this.onReply()
      });

      if (editable) {
        toolbar.push({
          icon: "edit",
          onClick: () => this.onEdit()
        });
      }

      return toolbar;
    });

    _defineProperty(this, "isFirstMessage", () => {
      const _this$props9 = this.props,
            index = _this$props9.index,
            formContext = _this$props9.formContext;

      if (index === 0) {
        return true;
      }

      return false;
    });

    _defineProperty(this, "isLastMessage", () => {
      const _this$props10 = this.props,
            index = _this$props10.index,
            formContext = _this$props10.formContext;
      const messagesCount = formContext.messagesCount;

      if (index + 1 === messagesCount) {
        return true;
      }

      return false;
    });
  }

  render() {
    const formData = this.props.formData;
    const _this$state = this.state,
          editing = _this$state.editing,
          expanded = _this$state.expanded,
          replying = _this$state.replying,
          reply = _this$state.reply;
    const label = formData.label || formData.status || undefined;
    const isFirstMessage = this.isFirstMessage();
    const isLastMessage = this.isLastMessage();
    const toolbar = this.getToolbar();
    let buttons;

    if (editing) {
      buttons = this.getEditButtons();
    } else if (replying) {
      buttons = this.getReplyButtons();
    } else if (isLastMessage) {
      buttons = [{
        label: "Reply",
        onClick: () => this.onReply()
      }];
    }

    const preview = _extends({}, formData, {
      label: label,
      editing: editing,
      expanded: expanded || isLastMessage,
      replying: replying,
      toolbar: toolbar,
      buttons: buttons
    });

    return _react.default.createElement(_InboxMessage.default, _extends({}, preview, {
      reply: reply,
      onToggle: this.onToggle,
      onChangeMessage: this.onChangeMessage,
      onChangeReply: this.onChangeReply
    }));
  }

}

_defineProperty(InboxEditorChild, "defaultProps", {
  buttons: [],
  settings: []
});

var _default = InboxEditorChild;
exports.default = _default;
module.exports = exports.default;